import { useAppState } from "../context-hooks/useAppState";
import { MAPNET_MIN_PLAN_YEAR } from "./useMapnetCoverage";
import { useMctFlags } from "./useMctFlags";

/**
 * No facilities management UX existed before the MGov redesign was enabled in
 * production. Therefore, this UX should only be available when both flags are on.
 * It's also a dependency of the original flag for all of our provider network
 * features, so additionally looks at that flag
 *
 * @example `const enableFacilitiesManagement = useEnableFacilitiesManagement();`
 */
export const useEnableFacilitiesManagement = (): boolean => {
  /**
   * `year` is typed as `string | undefined`, but facilities management is only
   * reachable from plan details, which requires the choosing a search year,
   * viewing that year's results, then opening a plan. By then the year is set.
   * If it somehow isn't, `Number(undefined)` is `NaN`. This returns `false`,
   * and which correctly returns a user to the landing page (fall through route).
   */
  const { year: planSearchYear } = useAppState();
  const year = Number(planSearchYear);
  const {
    tmpFeEnableMgovReskin,
    tmpFeEnableMapnetFacilityNetwork,
    tmpFeEnableProviderNetwork,
  } = useMctFlags();
  return (
    !!tmpFeEnableMapnetFacilityNetwork &&
    !!tmpFeEnableProviderNetwork &&
    !!tmpFeEnableMgovReskin &&
    year >= MAPNET_MIN_PLAN_YEAR
  );
};
